import React, { useContext, useState } from 'react'
import { InitializeContext } from '../../../App';
import { projectsData } from "../../../data/portfolioData";
import PortfolioCard from './PortfolioCard';
import { MdExpandMore } from 'react-icons/md';

const Fade = require("react-reveal/Fade");

const initialCardsToShow = 6;

export default function Portfolio() {
          const { theme } = useContext(InitializeContext);
          const [cardsToShow, setCardsToShow] = useState(initialCardsToShow);

          return (
                    <section id={'portfolio'} className={`md:py-16 pb-16 md:pb-10 ${theme ? 'text-white bg-[#212428]' : 'bg-[#ECF0F3] text-black'}`}>
                              <div className='text-center flex-col justify-center items-center md:flex'>
                                        <small className="text-sm mb-3">
                                                  PORTFOLIO.
                                        </small>
                                        <h1 className="font-bestWishes text-2xl md:text-3xl font-bold leading-tight">
                                                  My Recent Works
                                        </h1>
                              </div>
                              <div className="hero">
                                        <div className="hero-content w-full -mt-5">
                                                  <Fade bottom distance="20px">
                                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 w-full mx-auto mt-5 md:mt-10">
                                                                      {
                                                                                projectsData.slice(0, cardsToShow).map(item => (
                                                                                          <PortfolioCard
                                                                                                    key={item.id}
                                                                                                    image={item.image}
                                                                                                    title={item.title}
                                                                                                    category={item.category}
                                                                                                    live={item.live}
                                                                                                    client={item.client || ''}
                                                                                                    server={item.server || ''}
                                                                                          />
                                                                                ))
                                                                      }
                                                            </div>
                                                  </Fade>
                                        </div>
                              </div>

                              {
                                        cardsToShow < projectsData.length && (
                                                  <div className="flex justify-center items-center mt-3 md:mt-5">
                                                            <button onClick={() => setCardsToShow((prev) => prev + 3)} className={`flex items-center gap-1 border cursor-pointer py-2 md:py-3 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                                                                      See More <MdExpandMore size={22} />
                                                            </button>
                                                  </div>
                                        )
                              }
                    </section>
          )
}
